













































import Vue, { PropType } from 'vue';
import { MultiPointPacket, Objective } from '@/models/packet';

import Icon from '@/components/Icon.vue';

export default Vue.extend({
  components: {
    Icon
  },

  props: {
    packet: {
      type: Object as PropType<MultiPointPacket>,
      required: true
    }
  },

  computed: {
    name(): string {
      return this.packet.name;
    },

    description(): string {
      return this.packet.description;
    },

    objectives(): Objective[] {
      return this.packet.objectives.filter(obj => obj.isActive);
    },

    indicators(): { name: string; color: string }[] {
      return this.packet.outcomes
        .filter(out => out.isActive)
        .map(out => ({
          color: out.color,
          name: out.value
        }));
    }
  }
});
